import { render, staticRenderFns } from "./RmrKeywordChips.vue?vue&type=template&id=ee97d5fa&"
import script from "./RmrKeywordChips.vue?vue&type=script&lang=js&"
export * from "./RmrKeywordChips.vue?vue&type=script&lang=js&"
import style0 from "./RmrKeywordChips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
